import React from 'react'
import kebabCase from 'lodash.kebabcase'
import { Image } from '@/components/atoms/Image/Image'
import { DynamicHeading } from '@/components/molecules/DynamicHeading/DynamicHeading'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { HeroAboutTypes } from './types'

export function HeroAbout({ heading, description, image, progress, bg_image }: HeroAboutTypes) {
  return (
    <div
      className="bg-no-repeat bg-clip-padding bg-contain"
      style={bg_image?.image ? { backgroundImage: `url(${bg_image?.image})` } : undefined}
      id={heading ? kebabCase(heading[0].text) : ''}
    >
      <section className="flex flex-col tablet:items-center mx-auto px-24 laptop:px-90 py-24 tablet:py-64">
        <Image
          fixed={false}
          fluid
          data={image}
          loading="eager"
          options={{
            loading: 'eager',
            width: 1200,
            height: 467,
            maxWidth: 1200
          }}
          className="max-w-[1200px] !h-128 w-full tablet:!h-auto"
          imgClassName="
          mx-auto rounded-xl tablet:rounded-lg mb-48 !h-128 w-full tablet:!h-auto !object-contain tablet:object-fill
        "
        />
        {heading && (
          <DynamicHeading
            {...heading[0]}
            className="font-poppins text-headingL-mobile tablet:text-headingL font-bold text-text-dark-900 text-center mt-24 mb-16 tablet:mt-64 max-w-4xl"
          />
        )}
        <div className="text-bodyL text-center tablet:max-w-52 text-text-dark-900">
          {typeof description === 'string' ? description : <RichTextField data={description} />}
        </div>
        <div
          className="
        flex flex-col tablet:flex-row gap-24 tablet:space-y-0 justify-between text-center w-full max-w-52 mt-32 netbook:mt-64
        "
        >
          {progress.map(({ _uid, progress: progress_text }) => (
            <p
              className="font-poppins font-bold text-text-dark-900 text-headingS-mobile tablet:text-headingS tablet:text-center tablet:max-w-15"
              key={_uid}
            >
              {progress_text}
            </p>
          ))}
        </div>
      </section>
    </div>
  )
}
